import React, { Component } from 'react';
import { withLocalize } from "react-localize-redux";

class SeniorityPyramid extends Component {
  constructor(props) {
    super(props)
  }

  render() {

      const totalConsultant = this.props.data.reduce((accumulator, a) => { return accumulator + a.Railway + a.Energy }, 0)
      return (
          <div style={{ margin: "5px", width: "calc(100% - 5px)" }} >
            <div>
                <div style={{ display: "inline-block", width: "35%" }} />
                <div style={{ display: "inline-block", width: "35%",  color: "rgb(10, 131, 175)" }}>IKOS</div>
                <div style={{ display: "inline-block", width: "30%",  color: "rgb(25, 165, 132)" }}>IKER</div>
            </div>
            <div className="field-separator"/>
              {this.props.data.reverse().map((level, i) =>
                  <div
                      key={level + i}
                      style={{
                          display: "flex",
                          width: "100%",
                          height: "30px",
                          margin: "0px",
                          alignItems: "center",
                          justifyContent: "space-between"
                      }}
                  >
                      <div style={{ fontSize: "12px", color: 'black', display: "inline-block", width: "25%"}} >{this.props.translate(`Page.Consultant.seniority.${level.seniority}`)} </div>
                      <div style={{ fontSize: "12px", color: "rgb(10, 131, 175)", display: "inline-block", width: "10%" }} >{level.Railway} </div>
                      <div style={{
                          width: "55%",
                          display: "inline-block",
                          height: "100%",
                      }}>

                          <div
                              style={{
                                  width: "calc(50% - 1px)",
                                  borderRight: "1px solid",
                                  height: "100%",
                                  display: 'inline-block',
                                  borderRightColor: "rgb(235, 79, 30)"
                              }}
                          >
                              <div
                                  style={{
                                      color: "white",
                                      backgroundColor: "rgb(10, 131, 175)",
                                      transition: "all 0.5s ease-in",
                                      width: `${100 * level.Railway / totalConsultant}%`,
                                      height: "100%",
                                      position: "relative",
                                      left: `calc(100% - ${100 * level.Railway / totalConsultant}%)`
                                  }} />
                          </div>
                          <div
                              style={{
                                  width: "calc(50% - 1px)",
                                  borderLeft: "1px solid",
                                  height: "100%",
                                  display: 'inline-block',
                                  borderLeftColor: "rgb(235, 79, 30)"
                              }}
                          >
                              <div
                                  style={{
                                      color: "white",
                                      backgroundColor: "rgb(25, 165, 132)",
                                      transition: "all 0.5s ease-in",
                                      width: `${100 * level.Energy / totalConsultant}%`,
                                      height: "100%",
                                  }}
                              />
                          </div>
                      </div>
                      <div style={{ fontSize: "12px", color: "rgb(25, 165, 132)", display: "inline-block", width: "10%" }} >{level.Energy} </div>
                  </div>
              )}
          </div>
      )
  }
}

export default withLocalize(SeniorityPyramid)
